import { Fetch } from '../fetch/fetch-service';

export function fetchParties() {
  return Fetch('/idp-auth/pbasen/admin/Parties');
}

export function fetchParty(guid) {
  return Fetch(`/idp-auth/pbasen/admin/Parties?id=${guid}`);
}

export function fetchPartiesName() {
  return Fetch('/idp-auth/pbasen/getPartyNames');
}

export function postActivateParty(guid, status) {
  const jsonbody = JSON.stringify({
    active: status,
  });
  return Fetch(`/idp-auth/pbasen/admin/Party?id=${guid}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: jsonbody,
  });
}

export function postRemoveParty(id) {
  return Fetch(`/idp-auth/pbasen/admin/RemoveParty?id=${id}`, {
    method: 'POST',
    headers: {},
  });
}

export function putParty(party = {}) {
  return Fetch('/idp-auth/pbasen/admin/Party', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(party),
  });
}

export function fetchPartyHistory(id, from, to) {
  return Fetch(`/idp-auth/pbasen/admin/PartyHistory?id=${id}&from=${from}&to=${to}`);
}
